import * as React from "react";

export const BlouppyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    {...props}
  >
    <defs>
      <linearGradient y2={0.5} x2={1} y1={0.5} x1={0} id="a">
        <stop stopColor="#FFC1A3" offset={0} />
        <stop stopColor="#FFB1BB" offset={1} />
      </linearGradient>
      <linearGradient y2={0.5} x2={1} y1={0.5} x1={0} id="b">
        <stop stopColor="#EFC2EB" offset={0} />
        <stop stopColor="#AFC1EE" offset={1} />
      </linearGradient>
      <linearGradient y2={0.5} x2={1} y1={0.5} x1={0} id="c">
        <stop stopColor="#AFC1EE" offset={0} />
        <stop stopColor="#EFC2EB" offset={1} />
      </linearGradient>
      <linearGradient y2={0.483} x2={0.998} y1={0.483} x1={-0.015} id="d">
        <stop stopColor="#EFC2EB" offset={0} />
        <stop stopColor="#AFC1EE" offset={1} />
      </linearGradient>
      <linearGradient y2={0.493} x2={0.995} y1={0.493} x1={0.001} id="e">
        <stop stopColor="#FFC1A3" offset={0} />
        <stop stopColor="#FFB1BB" offset={1} />
      </linearGradient>
      <linearGradient y2={0.508} x2={0.981} y1={0.508} x1={-0.003} id="f">
        <stop stopColor="#EFC2EB" offset={0} />
        <stop stopColor="#AFC1EE" offset={1} />
      </linearGradient>
    </defs>
    <title>{"Layer 1"}</title>
    <path
      fill="url(#a)"
      d="M109.7 89.1c-2.5 4.4-5.9 8.6-10 12.4-9.2 8.5-21.1 13.5-33.5 14.8-24.8 2.6-48.2-9.8-44.5-40.2 1.2-9.7 5-18.9 10.7-26.9 1.8-2.6 4-5.2 6.4-7.2.8-.7 2-.7 2.8 0 .5.4.8 1 .8 1.6 0 .3-.1.6-.2 1-14.4 29.3-4.5 51.4 11.5 56.8 16.2 5.4 46-8.6 45.6-32.7.2-7.3-5.9-13.8-13.9-14.9-6.9-.9-15.3 2.1-22.2 12.1-5.4-7.6-3.8-18.7.1-25.7 2.2-4 4.6-7.6 5.9-11 1.4-3.7 1.4-7.1-1.6-10.3-5-5.3-23.4-7.4-42.1 10.3-6.2 5.8-11.1 12.7-14.8 20.3-7.8 16.2-5.8 26.1-5.6 27C-5.6 40.9 18.4 8.8 49.7 2.7h.1c4.8-.9 9.8-1.2 14.8-.8 5 .4 9.8 1.8 14 4.4C98.7 18.6 82 40 82 40c30.3-7.5 42.7 23.5 27.7 49.1z"
      className="st0"
    />
    <path
      fill="url(#b)"
      d="M69.1 29.2c1.4-3.7 1.4-7.1-1.6-10.3-5-5.3-23.4-7.4-42.1 10.3-6.1 5.8-11 12.7-14.7 20.3-8 16.6-5.7 26.6-5.6 27.1C-5.6 40.9 18.3 8.8 49.7 2.7h.2c21.2-3 29 8.9 19.2 26.5z"
      className="st1"
    />
    <path
      fill="url(#c)"
      d="M109.8 89.1c-.1 0-.1 0 0 0-2.6 4.4-5.9 8.6-10.1 12.4-9.2 8.5-21.1 13.5-33.5 14.8-24.8 2.6-48.2-9.8-44.5-40.2 1.2-9.7 5-18.9 10.7-26.9 1.8-2.6 4-5.2 6.4-7.2.8-.7 2-.7 2.8 0 .5.4.8 1 .8 1.6 0 .3-.1.6-.2 1-14.4 29.3-4.5 51.4 11.5 56.8 16.2 5.4 46-8.6 45.6-32.7.2-7.3-5.9-13.8-13.9-14.9 14.5-.8 31.2 16.6 24.4 35.3z"
      className="st2"
    />
    <path
      fill="url(#d)"
      d="m46.2 40.4-.8.7c-.4.3-.9.4-1.3.2-.6-.2-1.2-.6-1.7-.9-.1-.1-.1-.1-.2-.1s-.1-.1-.2-.1c-.2-.2-.4-.3-.6-.5-.2-.3-.5-.5-.7-.8l-.1-.1c-.1-.2-.2-.4-.2-.7 0-.2 0-.4.1-.6l.3-.6.1-.2v-.2l1.7 1.3.1.1.3.2.5.4 1 .7 1.3 1 .1.1.3.1z"
      className="st3"
    />
    <g opacity={0.6} className="st4">
      <path
        fill="#FFF"
        d="m41.4 36.8-.4 1c-.1.2-.2.5-.1.8 0 .3.1.5.3.7.1.2.3.3.4.5-.3-.3-.6-.6-.8-.9-.1-.2-.2-.4-.3-.7 0-.2 0-.5.1-.7l.5-1 .3.3z"
        className="st5"
      />
    </g>
    <g opacity={0.35} className="st6">
      <path
        fill="#390075"
        d="m44.4 39-1-.7-.4-.4-.3-.2-.1-.1-1.7-1.3v.1l.1.1c0 .1.1.1.1.1l.3.3 1.1.9.1.1.3.2.5.4.6.5h-.1l.3.3.1.1-.3.2h-.1l-.3.4c-.3.3-.7.4-1.1.3h-.1.1l1.2.6c.4.2 1 .1 1.3-.2l.6-.5.2-.1-1.4-1.1z"
        className="st7"
      />
    </g>
    <path
      fill="#EC1C24"
      d="m42.3 33.6-.7 2.9c-.2-.2-.5-.3-.8-.4h-.2c-1.1-.2-2.5.3-3.3.5-.2.1-.3.1-.4.1-.1 0-.1 0-.1-.1 1.5-3 3.2-3.6 4.4-3.4.5.1.8.2 1.1.4-.1-.1 0 0 0 0z"
      className="st8"
    />
    <g opacity={0.6} className="st4">
      <path
        fill="#FFF"
        d="M42.2 33.5c-1.3-.3-3.2.2-4.9 3.1-.2.1-.3.1-.4.1-.1 0-.1 0-.1-.1 2-3.9 4.4-3.7 5.4-3.1z"
        className="st5"
      />
    </g>
    <path
      fill="#D25658"
      d="M48.4 38.2c.9.8 1.8 3.1-1.5 6.1 0 0-.1 0-.1-.1.1-.6.3-3.6-1-4.6l2.6-1.4z"
      className="st9"
    />
    <path
      fill="#EC1C24"
      d="M46.9 44.3s-.1 0-.1-.1c0-.3.1-1.3 0-2.2-.1-.9-.4-1.9-1-2.3l2.6-1.4c.3.2.5.6.7 1 .4 1.1.2 2.8-2.2 5z"
      className="st8"
    />
    <g opacity={0.35} className="st6">
      <path
        fill="#390075"
        d="M46.8 42c-.1-.9-.4-1.9-1-2.3l2.6-1.4c.3.2.5.6.7 1-.3.8-1 1.8-2.3 2.7z"
        className="st7"
      />
    </g>
    <path
      fill="#FFF"
      d="M57.7 27.6c-.5 1.6-1.2 3.5-2.5 5.4-2.1 3.3-4.5 5.1-6.2 6.2-1.2.7-2.2 1.1-2.6 1.2-.1 0-.2.1-.2.1-.2-.1-.4-.1-.6-.2-.2-.1-.4-.1-.6-.2h-.1c-.3-.1-.5-.3-.8-.4l-.1-.1-.9-.6c-.1-.1-.3-.2-.4-.3-.1-.1-.2-.1-.3-.2-.1 0-.1-.1-.1-.1-.4-.4-.7-.7-1-1.1-.1-.1-.2-.3-.3-.4l-.1-.1-.1-.1v-.6c0-.5.1-1.3.4-2.3 0-.1 0-.2.1-.3.2-.7.4-1.5.8-2.3.1-.1.1-.2.2-.3.6-1.2 1.4-2.6 2.5-4 .3-.3.5-.7.8-1 1.2-1.4 2.4-2.4 3.6-3.2l.1-.1c.1-.1.2-.2.3-.2.1-.1.3-.2.4-.3.1-.1.3-.2.4-.3.2-.1.3-.2.5-.3.3-.1.6-.3.8-.4.1-.1.3-.1.4-.2.2-.1.4-.2.6-.2.2-.1.4-.1.5-.2 1.6-.5 2.8-.6 3.6-.6h.8s.1.1.1.3c.5.7 1.1 3.5 0 7.4z"
      className="st5"
    />
    <path
      fill="#EC1C24"
      d="M57.8 27.6c-.1-.1-.2-.3-.3-.4-.3-.4-.7-.8-1.1-1.1-1.7-1.6-3.6-3-5.8-4.1-.2-.1-.3-.2-.5-.3.1-.1.3-.2.4-.3.2-.1.3-.2.5-.3.3-.1.6-.3.8-.4.1-.1.3-.1.4-.2.2-.1.4-.2.6-.2.2-.1.4-.1.5-.2 1.7-.6 3.1-.7 3.8-.7h.7s.1.1.1.4c.3 1.2 1 4-.1 7.8z"
      className="st8"
    />
    <g opacity={0.44} className="st10">
      <path
        fill="url(#e)"
        d="M57.4 27.2c-.5 1.6-1.3 3.4-2.5 5.3-2.1 3.2-4.3 5.1-6.1 6.2-1.1.7-2.1 1.1-2.6 1.3-.1 0-.2.1-.3.1-.2.1-.3.1-.3.1-.2-.1-.4-.1-.6-.2h-.1c-.3-.1-.6-.2-.8-.4-.1 0-.1-.1-.2-.1-.3-.2-.6-.3-.9-.5-.1-.1-.3-.2-.4-.3-.1-.1-.2-.1-.3-.2-.1 0-.1-.1-.1-.1-.1-.1-.2-.1-.3-.2-.3-.3-.6-.6-.8-.9-.1-.1-.2-.3-.3-.5l-.1-.1.1-.2V36.2l.1.1c.5.5 1.1.8 1.8 1.1.1 0 .1.1.2.1.1.1.2.1.4.1.2.1.5.1.7.2.4.1.8.1 1.2.1 1 0 2-.4 2.9-.9 1.6-1.1 3.7-2.8 5.6-5.6-1.2 1-3 1.1-4.3.1-.9-.7-1.4-1.7-1.4-2.8 0-.7.3-1.5.7-2.1l.1-.1s0-.1.1-.1c.2-.2.3-.4.5-.5.2-.1.4-.3.6-.4.1 0 .1 0 .1-.1.1 0 .1-.1.2-.1h.5c.1 0 .3-.1.5-.1h.3c.7 0 1.4.1 2.1.5.1.1.2.1.2.2 1.1.9 1.6 2.3 1.3 3.6.6-1.1 1.1-2.2 1.5-3.2.8-2.5.9-4.6.8-6.1v-.4h.6v.1c0 .1.1.2.1.3-.1 1.1.2 3.7-.8 7z"
        className="st11"
      />
    </g>
    <g opacity={0.35} className="st6">
      <path fill="#390075" d="M40.7 35.7z" className="st7" />
    </g>
    <g opacity={0.35} className="st6">
      <path fill="#390075" className="st7" d="M40.7 35.7z" />
    </g>
    <g opacity={0.6} className="st4">
      <path
        fill="#FFF"
        d="M58 19.9h-.7c-1.4.1-3.9.5-6.6 2-.2.1-.3.2-.5.3-.2-.1-.3-.2-.5-.2.1-.1.3-.2.4-.3.1-.1.3-.2.4-.3.2-.1.3-.2.5-.3.3-.1.6-.3.8-.4.1-.1.3-.1.4-.2.2-.1.4-.2.6-.2.2-.1.4-.1.5-.2 1.7-.6 3.1-.7 3.8-.7h.7s.1.3.2.5z"
        className="st5"
      />
    </g>
    <circle
      fill="#EC1C24"
      cy={3.04}
      cx={88.592}
      className="st8"
      transform="rotate(-52.778 95.26 53.183)"
      r={3.1}
    />
    <path
      fill="#390075"
      d="M54.4 27.8c0-.1 0-.2-.1-.3 0-.1 0-.2-.1-.2-.1-.4-.3-.7-.6-1-.1-.2-.3-.3-.5-.5-.5-.5-1.1-.8-1.8-.8h-.5c-.8.1-1.6.5-2.1 1.2 0 0 0 .1-.1.1-.5.7-.7 1.5-.6 2.3 0 .3.1.6.2.8.1.1.1.2.2.3.1.1.2.3.3.4.1.1.1.2.2.3l.3.3c.6.4 1.2.6 1.9.6.9 0 1.9-.4 2.5-1.2.4-.6.6-1.3.6-1.9.2-.2.2-.3.2-.4zm-4.9 2.8c-.1 0-.1 0 0 0-.1-.1-.3-.2-.3-.3-.2-.2-.3-.4-.4-.6 0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1-.1-.3-.2-.5-.2-.8-.1-.8.1-1.6.6-2.3.5-.6 1.2-1.1 2-1.2.5-.1 1 0 1.5.2.1.1.3.1.4.2h.1s.1 0 .1.1c.1 0 .1.1.2.1l.3.3.2.2.1.1c0 .1.1.1.1.2.2.3.3.5.4.8 0 .1.1.2.1.4.1.8-.1 1.6-.6 2.3-1.2 1.4-3.1 1.6-4.4.6z"
      className="st7"
    />
    <g opacity={0.6} className="st4">
      <path
        fill="#FFF"
        d="M53.7 26.2c-.1 0-.1-.1-.2-.1-1.4-1-3.3-.8-4.3.6-.9 1.2-.8 2.9.2 3.9-1.2-1.1-1.4-2.9-.4-4.2 1-1.4 3-1.6 4.3-.6.1.2.3.3.4.4z"
        className="st5"
      />
    </g>
    <g opacity={0.35} className="st6">
      <path
        fill="#371A45"
        d="M53.7 30.1c-1 1.4-3 1.6-4.3.6-.4-.3-.7-.7-1-1.2.1.2.3.3.5.5 1.4 1 3.3.8 4.3-.6.7-.9.8-2.1.4-3.1.9 1 1 2.6.1 3.8z"
        className="st13"
      />
      <path
        fill="#390075"
        d="M54.4 27.8c0-.1 0-.2-.1-.3 0-.1 0-.2-.1-.2-.1-.4-.3-.7-.6-1 .1.2.2.4.2.7.2.8 0 1.7-.6 2.4-.5.6-1.2 1.1-2 1.2-.8.1-1.6-.1-2.2-.6l-.2-.2-.3-.3c.1.1.1.2.2.3.1.1.2.3.3.4.1.1.1.2.2.3l.3.3c.6.4 1.2.6 1.9.6.9 0 1.9-.4 2.5-1.2.4-.6.6-1.3.6-1.9-.1-.3-.1-.4-.1-.5zm-4.9 2.8c-.1 0-.1 0 0 0-.1-.1-.3-.2-.3-.3-.2-.2-.3-.4-.4-.6l.2.2c.1.1.2.2.3.2.6.4 1.3.5 2 .4.8-.1 1.6-.6 2.1-1.2s.7-1.4.6-2.1c0-.2-.1-.5-.1-.7.2.3.3.5.4.8 0 .1.1.2.1.4.1.8-.1 1.6-.6 2.3-1.1 1.4-3 1.6-4.3.6z"
        className="st7"
      />
    </g>
    <path
      fill="#273240"
      d="M54.6 27.7c-.1-.9-.6-1.6-1.2-2.2 0 0-.1 0-.1-.1-.7-.5-1.6-.8-2.5-.7-.9.1-1.7.6-2.2 1.3-.5.7-.8 1.5-.7 2.3v.1c.1.9.6 1.7 1.3 2.2 1.5 1.1 3.5.8 4.7-.7.6-.4.8-1.3.7-2.2zM49.1 30l-.1-.1c-.1-.2-.2-.4-.3-.5-.1-.2-.2-.5-.2-.7-.1-.8.1-1.5.6-2.1.5-.6 1.1-1 1.9-1.1.5-.1 1 0 1.5.2l.6.3c.4.3.6.6.8 1 0 .1.1.1.1.1s0 .1.1.1c.1.2.1.4.1.6.1.8-.1 1.5-.6 2.1-.9 1.2-2.7 1.5-3.9.6l-.3-.3c-.2-.1-.3-.1-.3-.2z"
      className="st14"
    />
    <circle fill="url(#f)" r={2} cy={28.1} cx={51.3} className="st12" />
    <g opacity={0.3} className="st16">
      <path
        fill="#FFF"
        d="M52.8 29.3c-.7.9-1.9 1-2.8.4-.2-.1-.3-.3-.5-.5h.1c.9.7 2.1.5 2.8-.4.5-.7.5-1.6.1-2.3.8.8 1 2 .3 2.8z"
        className="st5"
      />
    </g>
    <g opacity={0.35} className="st6">
      <path
        fill="#390075"
        d="M53 27.2s0-.1 0 0c-.9-.7-2.2-.6-2.8.3-.5.7-.5 1.5-.1 2.2-.8-.7-.9-1.9-.3-2.7.7-.9 1.9-1 2.8-.4.1.2.3.4.4.6z"
        className="st7"
      />
    </g>
    <path
      fill="#273240"
      d="M52.6 26.4c-.5-.4-1-.5-1.6-.4-.6.1-1.1.4-1.5.8-.7 1-.6 2.4.4 3.1.4.3.8.4 1.3.4.7 0 1.3-.3 1.8-.9.7-.9.6-2.3-.4-3zm-2.3 3.2c0-.1-.1-.1 0 0-.1-.1-.1-.1 0 0-.1-.1-.1-.1 0 0-.2-.1-.3-.3-.4-.4-.4-.6-.4-1.4.1-2 .3-.4.7-.6 1.1-.7.4-.1.9.1 1.3.3 0 0 .1 0 .1.1.2.1.3.3.4.5.3.6.3 1.3-.1 1.9-.7.6-1.8.8-2.5.3z"
      className="st14"
    />
    <g opacity={0.2} className="st17">
      <path
        fill="#FFF"
        d="M54.7 21.3c-.3-.4-1.3-.2-1.8.1-.5.3-.7.6-.6.8.2.3.6.2 1.1 0 .4-.2 1.6-.4 1.3-.9z"
        className="st5"
      />
    </g>
    <g opacity={0.2} className="st17">
      <path
        fill="#FFF"
        d="M56.2 21.1c-.2-.3-.9-.4-1.1-.3-.3.1-.4.3-.2.5.2.3.5.3.7.2.2-.1.9 0 .6-.4z"
        className="st5"
      />
    </g>
    <path
      fill="#EC1C24"
      d="M44.7 38.8c-.9 1.2-2.8 1.7-2.8 1.7 0-.2 0-2 .9-3.1.8-1.1 2.3-1.4 2.6-1.4s.2 1.6-.7 2.8z"
      className="st8"
    />
    <g opacity={0.6} className="st4">
      <path
        fill="#FFF"
        d="M45.5 36v.3c-.5.1-1.7.4-2.4 1.4-.7.9-.8 2.2-.9 2.8-.2.1-.3.1-.3.1 0-.2 0-2 .9-3.1.9-1.2 2.4-1.5 2.7-1.5z"
        className="st5"
      />
    </g>
    <g opacity={0.35} className="st6">
      <path
        fill="#390075"
        d="M44.7 38.8c-.9 1.2-2.8 1.7-2.8 1.7l3.4-4.5s.3 1.6-.6 2.8z"
        className="st7"
      />
    </g>
  </svg>
);
